<div id="virtual-grid-header" class="virtual-grid-header" #innerWorkListHeader [style.max-width.px]="gridWidth">
  <div
    id="virtual-grid-header-row"
    class="virtual-grid-header-row"
    *ngIf="!hidden"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="drop($event)"
  >
    <div class="virtual-grid-frozen-columns" [style.width.px]="frozenSize" [style.min-width.px]="frozenSize">
      <div
        class="flex flex--middle flex--justify checkbox-select virtual-grid-cell virtual-grid-header-cell"
        *ngIf="checkboxSelection"
      >
        <label class="checkbox">
          <input
            type="checkbox"
            class="checkbox__input"
            [checked]="selectAll"
            (click)="selectAll = !selectAll; selectAllChange.emit(selectAll)"
          />
          <span class="checkbox__label"></span>
        </label>

        <div class="vertical"></div>
      </div>

      <ng-container *ngFor="let column of frozenColumns; index as i">
        <div
          #cells
          *ngIf="!column.isHidden"
          class="flex flex--middle virtual-grid-cell virtual-grid-header-cell draggable-box"
          (contextmenu)="openContextMenu($event, column); $event.preventDefault()"
          [id]="'header--cel-' + layout.indexOf(column)"
          [style.width.px]="column.width"
          [style.min-width.px]="column.width || column.minWidth"
          [style.max-width.px]="column.maxWidth"
          [ngClass]="column.headerStyleClasses"
          [class.sized]="column.width != undefined"
          [class.size-2]="column.responsiveSize === 2"
          [class.size-3]="column.responsiveSize === 3"
          [class.filter-active]="isActiveFilterColumn(column)"
          [class.flex--justify]="!column.headerLabel"
          cdkDrag
          (cdkDragStarted)="dragStarted()"
          (cdkDragEnded)="isDraging = false"
        >
          <div *cdkDragPlaceholder></div>

          <div id="{{ 'vitual-gird-header-name-' + column.propertyName }}" *cdkDragPreview class="text-16">
            {{ column.headerLabel | translate }}
          </div>

          <ng-container [ngTemplateOutlet]="gridHeaderCell" [ngTemplateOutletContext]="{ column: column, index: i }">
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div
      #unfrozen
      class="virtual-grid-unfrozen-columns"
      [scrollLeft]="horizontalScrollPosition * rtlSignal"
      (scroll)="onScroll()"
    >
      <ng-container *ngFor="let column of unfrozenColumns; index as i">
        <div
          #cells
          *ngIf="!column.isHidden"
          class="flex flex--middle virtual-grid-cell virtual-grid-header-cell draggable-box"
          (contextmenu)="openContextMenu($event, column); $event.preventDefault()"
          [id]="'header--cel-' + layout.indexOf(column)"
          [style.width.px]="column.width"
          [style.min-width.px]="column.width || column.minWidth"
          [style.max-width.px]="column.maxWidth"
          [ngClass]="column.headerStyleClasses"
          [class.sized]="column.width != undefined"
          [class.size-2]="column.responsiveSize === 2"
          [class.size-3]="column.responsiveSize === 3"
          [class.filter-active]="isActiveFilterColumn(column)"
          [class.flex--justify]="!column.headerLabel"
          cdkDrag
          (cdkDragStarted)="dragStarted()"
          (cdkDragEnded)="isDraging = false"
        >
          <div *cdkDragPlaceholder></div>

          <div id="{{ 'vitual-gird-header-name-' + column.propertyName }}" *cdkDragPreview class="text-16">
            {{ column.headerLabel | translate }}
          </div>

          <ng-container [ngTemplateOutlet]="gridHeaderCell" [ngTemplateOutletContext]="{ column: column, index: i }">
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #gridHeaderCell let-column="column" let-index="index">
  <div class="flex flex--middle text-ellipsis">
    <div
      id="{{ 'vitual-gird-header-cell-name-' + column.headerLabel }}"
      class="text-ellipsis u-mr----"
      [class.sortable]="isColumnSortable(column)"
      [disableTooltip]="isDraging"
      [tooltip]="column.tooltip || column.headerLabel | translate"
      [overflowOnly]="column.tooltipOverflowOnly !== false"
      [delay]="column.tooltipDelay !== null && column.tooltipDelay !== undefined ? column.tooltipDelay : 800"
      (click)="onHeaderLabelClick(column)"
    >
      {{ column.headerLabel | translate }}
      <!-- safari browser displaying 2 tooltips for overflowed text. One added by browser and other is wfm tooltip-->
      <!--Hack to avoid browser added tooltip in safari. Ref https://zzz.buzz/2017/07/31/prevent-tooltip-over-truncated-text-in-safari/-->
      <div></div>
    </div>
  </div>

  <div class="grid-header-dropdown">
    <ng-container
      [ngTemplateOutlet]="gridHeaderDropdown"
      [ngTemplateOutletContext]="{ column: column, index: index }"
    ></ng-container>
  </div>

  <div class="flex flex--middle">
    <!-- sort field -->
    <div *ngIf="!!column.multiFieldItems && !!column.defaultSort">
      <span class="header-icon-wrapper">
        <svg-icon
          class="modified-item-icon-fill"
          [name]="
            sortCriteria &&
              sortCriteria.length && [
                sortCriteria[0].column,
                sortCriteria[0].sortField && sortCriteria[0].sortField.icon
              ] | getData: getSortedFieldIndicator:column:sortCriteria
          "
          [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
        ></svg-icon>
      </span>
    </div>

    <!-- sort indicator -->
    <ng-container [ngTemplateOutlet]="gridHeaderSortIcon" [ngTemplateOutletContext]="{ column: column }"></ng-container>

    <!-- kebab -->
    <ng-container *ngIf="!!column.multiFieldItems || isColumnFilterable(column)">
      <span
        id="{{ 'vitual-gird-header-moreoption-' + column.propertyName }}"
        class="filter-actions-input-icon header-icon-wrapper"
        (click)="onMoreOptionsClick(column)"
      >
        <svg-icon
          name="ico-more-vertical-16"
          [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
          [svgClass]="isActiveFilterColumn(column) ? 'modified-item-icon-fill' : 'icon-fill'"
        ></svg-icon>
      </span>
    </ng-container>
    <!-- resizable divider -->
    <div
      class="flex flex--row flex--nowrap flex--baseline flex--right column-resizer"
      (click)="$event.stopPropagation()"
      (mousedown)="resizeStart($event, column)"
    >
      <div class="vertical"></div>
    </div>
  </div>
</ng-template>

<ng-template #gridHeaderContextMenu let-column="column" let-index="index">
  <ul role="menu" class="menu__panel menu__panel--right virtual-grid-context-menu" aria-hidden="false">
    <ng-container *ngFor="let menuOperation of contextMenuOperations">
      <li class="menu__item-wrap" *ngIf="!menuOperation.isHidden">
        <div class="menu__item-divider" *ngIf="menuOperation.enableDivider"></div>
        <button
          type="button"
          class="menu__item text-16"
          (click)="contextMenuSelected(menuOperation); $event.stopPropagation()"
        >
          <span class="menu__item-text">{{ menuOperation.label | translate }}</span>
        </button>
      </li>
    </ng-container>
  </ul>
</ng-template>

<ng-template #gridHeaderSortIcon let-column="column">
  <ng-container *ngIf="isColumnSorted(column, true)">
    <span class="header-icon-wrapper sort-icon-placeholder" (click)="onToggleColumnSort(column)">
      <svg-icon name="ico-arrow-up-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16 }" svgClass="icon-fill">
      </svg-icon>
    </span>
  </ng-container>
  <ng-container *ngIf="isColumnSorted(column, false)">
    <span class="header-icon-wrapper sort-icon-placeholder" (click)="onToggleColumnSort(column)">
      <svg-icon name="ico-arrow-down-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16 }" svgClass="icon-fill">
      </svg-icon>
    </span>
  </ng-container>
</ng-template>

<ng-template #gridHeaderDropdown let-column="column" let-index="index">
  <wfm-dropdown
    [maxHeight]="450"
    [topPosition]="1"
    [isOpen]="isActiveFilterColumn(column)"
    (isOpenChange)="setActiveFilterColumn(column, $event)"
    (isOutsideMousedown)="setActiveFilterColumn(column, $event)"
  >
    <virtual-grid-header-dropdown
      class="flex"
      [column]="column"
      [isHidden]="column.isHidden"
      [filterConfig]="column.filterConfig"
      [filterComponent]="column.filterComponent"
      [filterData]="getFilterData(column)"
      [isActive]="isActiveFilterColumn(column)"
      [sortCriteria]="sortCriteria"
      [accessibleInstitutes]="accessibleInstitutes"
      [instituteSeparationEnabled]="instituteSeparationEnabled"
      (closeRequest)="setActiveFilterColumn(column, false); activateFilter(column, $event)"
      (filterDataChange)="setActiveFilterColumn(column, false); onFilterDataChange(column, $event)"
      (itemSortSelectionChange)="itemSortSelectionChange($event)"
    >
    </virtual-grid-header-dropdown>
  </wfm-dropdown>
</ng-template>
